import React, { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';
import { MultiSelect } from 'primereact/multiselect';
// import { VirtualScroller } from 'primereact/virtualscroller';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';

import toast from 'react-hot-toast';
import FileDownload from 'js-file-download';
import planningService from '@services/planning.service';
import gisservice from '@services/gisservice.service';
import strftime from 'strftime';
import jwt_decode from 'jwt-decode';

const KML_utilization = () => {
  // eslint-disable-next-line
  const token = jwt_decode(localStorage.getItem('plano-jwt'));
  const userName =
    token['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];

  const [isTDD, setIsTDD] = useState(false);
  const [baseRadius, setbaseRadius] = useState(100);
  const [radiusIncrementStep, setradiusIncrementStep] = useState(30);
  const [beamWidth, setBeamWidth] = useState(60);
  const [regions, setRegions] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [sites, setSites] = useState([]);
  const technologies = ['2G', '3G', '4G', 'TDD BH'];
  const [kpis, setKpis] = useState([]);
  const [kpiStatus, setKpiStatus] = useState({});

  // eslint-disable-next-line
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [selectedSite, setSelectedSite] = useState([]);
  const [selectedTechnology, setSelectedTechnology] = useState('4G');
  const [selectedKPIs, setSelectedKPIs] = useState([]);
  const [relatedKPIs, setRelatedKPIs] = useState([]);
  technologies.map((tech) => ({
    label: tech,
    value: tech,
  }));
  const [kpisDisabled, setKpisDisabled] = useState(false);

  const onTechnologyChange = (tech) => {
    console.log(kpis);
    setSelectedKPIs([]);
    setSelectedTechnology(tech);
    switch (tech) {
      case '2G':
        setKpisDisabled(false);
        setIsTDD(false);
        setIsBH(false);
        setRelatedKPIs(
          kpis
            .filter((kpi) => kpi.Technology === '2G')
            .map((kpi) => ({ label: kpi.label, value: kpi.value }))
        );
        console.log(
          kpis
            .filter((kpi) => kpi.Technology === '2G')
            .map((kpi) => ({ label: kpi.label, value: kpi.value }))
        );
        break;
      case '3G':
        setKpisDisabled(false);
        setIsBH(false);
        setIsTDD(false);
        setRelatedKPIs(
          kpis
            .filter((kpi) => kpi.Technology === '3G')
            .map((kpi) => ({ label: kpi.label, value: kpi.value }))
        );
        break;
      case '4G':
        setKpisDisabled(false);
        setIsTDD(false);
        setIsBH(false);
        setRelatedKPIs(
          kpis
            .filter((kpi) => kpi.Technology === '4G')
            .map((kpi) => ({ label: kpi.label, value: kpi.value }))
        );
        break;
      case '4G BH':
        setKpisDisabled(false);
        setIsTDD(false);
        setIsBH(true);
        setRelatedKPIs(
          kpis
            .filter((kpi) => kpi.Technology === '4G BH')
            .map((kpi) => ({ label: kpi.label, value: kpi.value }))
        );
        break;
      case 'TDD':
        setKpisDisabled(false);
        setIsTDD(true);
        setIsBH(false);
        setRelatedKPIs(
          kpis
            .filter((kpi) => kpi.Technology === 'TDD')
            .map((kpi) => ({ label: kpi.label, value: kpi.value }))
        );
        break;
      case 'TDD BH':
        setKpisDisabled(false);
        setIsTDD(true);
        setIsBH(true);
        setRelatedKPIs(
          kpis
            .filter((kpi) => kpi.Technology === 'TDD BH')
            .map((kpi) => ({ label: kpi.label, value: kpi.value }))
        );
        break;
      default:
        // A lot of stuff should be disabled
        setKpisDisabled(true);
        break;
    }
  };

  async function fetchKpis() {
    try {
      const res = await gisservice.Post('/getLegends', { userName });
      setKpis(
        res.data.map((r) => ({
          label: r.legendName,
          value: r.legendName,
          Technology: r.Technology,
        }))
      );
      setRelatedKPIs(
        res.data
          .filter((r) => r.Technology === '4G')
          .map((r) => ({ label: r.legendName, value: r.legendName }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchRegions() {
    try {
      const res = await planningService.Get('/regions');
      setRegions(
        res.data
          .filter((r) => r)
          .sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          })
          .map((r) => ({ label: r, value: r }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchProvinces() {
    try {
      const res = await planningService.Get('/provinces');
      setProvinces(
        res.data
          .filter((a) => a)
          .sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          })
          .map((p) => ({ label: p, value: p }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchCities() {
    try {
      const res = await planningService.Get('/cities');
      setCities(
        res.data
          .filter((a) => a)
          .sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          })
          .map((c) => ({ label: c, value: c }))
      );
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchSites() {
    try {
      const res = await planningService.Get('/sites');
      setSites(res.data.map((s) => ({ label: s, value: s })));
    } catch (error) {
      console.log(error);
    }
  }
  async function fethStatus() {
    const { data } = await planningService.Get('/getLastKpiUpdates');
    setKpiStatus(data);
  }
  function fetchDatas() {
    fetchProvinces();
    fetchRegions();
    fetchCities();
    fetchSites();
    fetchKpis();
    fethStatus();
  }
  const getSeverity = (docs) => {
    let hasCount = docs.docCount > 10 ? true : false;
    switch (hasCount) {
      case true:
        return 'success';
      case false:
        return 'danger';
      default:
        return null;
    }
  };
  const publicBodyTemplate = (docs) => {
    // console.log(docs);
    return <Tag value={docs.docCount} severity={getSeverity(docs)}></Tag>;
  };
  useEffect(() => {
    fetchDatas();
    // eslint-disable-next-line
  }, [userName]);
  const [isBH, setIsBH] = useState(false);

  const onClear = () => {
    setSelectedRegion([]);
    setSelectedProvince([]);
    setSelectedCity([]);
    setSelectedSite([]);
    setIsBH(false);
    setIsTDD(false);
    setSelectedTechnology('');
    setSelectedKPIs([]);
  };

  const onFinish = async () => {
    const postObj = {
      region: selectedRegion ? selectedRegion : '',
      province: selectedProvince ? selectedProvince : '',
      city: selectedCity ? selectedCity : '',
      site: selectedSite ? selectedSite : '',
      technology: selectedTechnology,
      kpis: selectedKPIs,
      baseRadius,
      radiusIncrementStep,
      beamWidth,
      isBH,
      isTDD,
    };
    try {
      const res = await planningService.PostBlob(
        '/irancell/kml/utilization',
        postObj
      );
      let nameOfFile = '';
      for (let i = 0; i < postObj.kpis.length; i++) {
        let kpi = postObj.kpis[i];
        nameOfFile += kpi;
      }
      nameOfFile += '_';
      if (postObj.isBH) nameOfFile += 'BusyHour_';
      if (postObj.isTDD) nameOfFile += 'TDD_';
      nameOfFile += strftime('%Y-%m-%d-%H-%M-%S');
      FileDownload(res.data, `${nameOfFile}.kmz`);
    } catch (err) {
      console.log("err", err);
      // toast.error(err);
    }
  };

  return (
    <div className="p-5 h-full img-bg img-bg-google-earth">
      <div className="bg-white border border-gray-200 rounded-md p-5 grid grid-cols-12 gap-4">
        <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
          <MultiSelect
            className="w-full"
            id="region"
            value={selectedRegion}
            options={regions}
            onChange={(e) => setSelectedRegion(e.value)}
            showClear
            filter
            display="chip"
          />
          <label htmlFor="region">Region</label>
        </span>
        <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
          <MultiSelect
            className="w-full"
            id="province"
            value={selectedProvince}
            options={provinces}
            onChange={(e) => setSelectedProvince(e.value)}
            showClear
            filter
            placeholder="Select Province"
            display="chip"
          />
          <label htmlFor="province">Province</label>
        </span>
        <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
          <MultiSelect
            className="w-full md:w-20rem"
            id="city"
            value={selectedCity}
            options={cities}
            onChange={(e) => setSelectedCity(e.value)}
            virtualScrollerOptions={{ itemSize: 43 }}
            maxSelectedLabels={3}
            display="chip"
            showClear
            filter
            placeholder="Select City"
            showSelectAll={false}
          />
          <label htmlFor="city">City</label>
        </span>
        <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
          <MultiSelect
            className="w-full md:w-20rem"
            id="site"
            value={selectedSite}
            options={sites}
            onChange={(e) => setSelectedSite(e.value)}
            virtualScrollerOptions={{ itemSize: 43 }}
            showClear
            filter
            maxSelectedLabels={3}
            display="chip"
            showSelectAll={false}
          />
          <label htmlFor="site">Site</label>
        </span>
        {/* Second row */}
        <span className="p-float-label mt-6 w-full md:w-20rem col-span-2 col-start-1">
          <Dropdown
            id="tech"
            className="w-full"
            value={selectedTechnology}
            options={technologies}
            onChange={(e) => onTechnologyChange(e.value)}
            filter
            display="chip"
          />
          <label htmlFor="tech">Technology</label>
        </span>
        <span className="p-float-label mt-6 w-full md:w-20rem col-span-2">
          <MultiSelect
            id="kpis"
            className="w-full"
            value={selectedKPIs}
            options={relatedKPIs}
            onChange={(e) => setSelectedKPIs(e.value)}
            showClear
            filter
            disabled={kpisDisabled}
            display="chip"
          />
          <label htmlFor="kpis">KPIs</label>
        </span>
        <span className="p-float-label mt-6 col-span-2">
          <InputNumber
            className="w-full"
            id="radius-input"
            value={baseRadius}
            onValueChange={(e) => setbaseRadius(e.value)}
            min={0}
            max={100}
            showButtons
          />
          <label htmlFor="radius-input">Base Radius</label>
        </span>
        <span className="p-float-label mt-6 col-span-2">
          <InputNumber
            className="w-full"
            id="radius-increment-step"
            value={radiusIncrementStep}
            onValueChange={(e) => setradiusIncrementStep(e.value)}
            min={0}
            max={100}
            showButtons
          />
          <label htmlFor="radius-increment-step">Radius Increment Step</label>
        </span>
        <span className="p-float-label mt-6 col-span-2">
          <InputNumber
            className="w-full"
            id="bewmwidth"
            value={beamWidth}
            onValueChange={(e) => setBeamWidth(e.value)}
            min={0}
            max={100}
            showButtons
            defaultValue={60}
          />
          <label htmlFor="bewmwidth">Beam Width</label>
        </span>
        <div className='mt-6 w-full col-span-1 col-start-1'></div>
        <Button
          className="mt-6 col-end-12"
          label="Download"
          raised
          onClick={onFinish}
        />
        <Button
          className="mt-6"
          label="Clear"
          severity="secondary"
          raised
          onClick={onClear}
        />
      </div>
      <div className='bg-white border border-gray-200 rounded-md p-5 grid'>
        <DataTable value={kpiStatus} tableStyle={{ minWidth: '50rem' }}>
          <Column field="Name" header="Category"></Column>
          <Column body={publicBodyTemplate} header="Doc Count"></Column>
          <Column field="lastUpdate" header="Last Update"></Column>
        </DataTable>
      </div>
    </div>
  );
};

export default KML_utilization;
